import { render, staticRenderFns } from "./main-judgment.vue?vue&type=template&id=2d529a7c&scoped=true&"
import script from "./main-judgment.vue?vue&type=script&lang=js&"
export * from "./main-judgment.vue?vue&type=script&lang=js&"
import style0 from "./main-judgment.vue?vue&type=style&index=0&id=2d529a7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d529a7c",
  null
  
)

export default component.exports